import { inject, Injectable } from '@angular/core';

import { CompassIconService } from '@pwc/compass/icon';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  iconService: CompassIconService = inject(CompassIconService);

  registerCompassIcon(icon: string) {
    if (!this.iconService.isIconRegistered(icon)) {
      this.iconService.registerIcon(
        `compass-${icon}`,
        `assets/icons/${icon}.svg`,
      );
    }
  }
}
